export default {
  ownerID: 3,
  showStatementDevalue: true,
  showStatementRetire: true,
  showStatementStop: true,
  showStatementActivate: true,
  showChangePIN: true,
  hideFees: true
}
